import { GenericAuthContext } from '@src/authContexts';
import { useUserData } from '@util/customhooks/useUserData';
import { NavLinkData } from '@util/navLinkData';
import React from 'react';
import AnonymousLayout from './AnonymousLayout';
import ErrorLayout from './ErrorLayout';
import LoadingLayout from './LoadingLayout';
import AuthenticatedLayout from './AuthenticatedLayout';
import ComingSoon from '@views/common/ComingSoon';

const commonRoutes: NavLinkData[] = [
  {
    to: '/comingsoon',
    component: ComingSoon,
    inNavbar: false,
  },
];

const Layout = () => {
  const [user, idToken, userDoc, loading, error] = useUserData();

  if (loading) {
    return <LoadingLayout></LoadingLayout>;
  }

  if (error) {
    return <ErrorLayout></ErrorLayout>;
  }

  if (!user || !userDoc || !idToken) {
    return <AnonymousLayout baseRoutes={commonRoutes}></AnonymousLayout>;
  }

  return (
    <GenericAuthContext.Provider value={{ user, idToken, userDoc }}>
      <AuthenticatedLayout baseRoutes={commonRoutes}></AuthenticatedLayout>
    </GenericAuthContext.Provider>
  );
};

export default Layout;
